// multi object includes the entry point and urls of each hub that uses this template
const multi = {
    en: 'resources.ecovadis.com/',
    fr: 'resources.ecovadis.com/fr',
    ce: 'customerhub.ufcontent.com/',
    de: 'resources.ecovadis.com/de',
    es: 'resources.ecovadis.com/es',
    it: 'resources.ecovadis.com/it',
    cs: 'hub.ecovadis.com/',
    enStaging: 'ecovadis-staging.ufcontent.com/',
    jp: 'resources.ecovadis.com/ja',
};

const devOptions = {
    shortHubUrl: multi.en, //change me to the base url of your hub (no http(s) or www)
    // STAGING HUB IS HTTP
    fullHubUrl: `https://${multi.en}` + '?ufcc_onbrand_local', //exact url to access hub, leave onbrand query string
    cihostFolder: 'ecovadis-multi-v1', //change me to the cihost folder name
    remindMeToGit: true,
    notifyOnBuildSuccess: true, //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;


// WEBPACK FOOTER //
// ./dev-options.js